// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__28Uwz","footer":"ChangeClinic_footer__UnrSI"};